export const serviceMenuItems = [
  { label: "Packages", path: "/packages", icon: "solar:box-linear" },
  { label: "Hotels", path: "/hotels", icon: "solar:buildings-2-linear" },
  { label: "Transport", path: "/transportation", icon: "solar:bus-linear" },
  { label: "Visas", path: "/visas", icon: "solar:passport-linear" },
  { label: "Flights", path: "/flights", icon: "ri-flight-takeoff-line" },
  { label: "Ziyarat", path: "/ziyarat-packages", icon: "solar:map-point-linear" },
];

export const agencyMenuItems = [
  { label: "KYC", path: "/agency-detail", icon: "solar:buildings-2-linear" },
  { label: "Customers", path: "/customers", icon: "solar:user-id-outline" },
  { label: "Users", path: "/users", icon: "solar:users-group-rounded-outline" },
];

export const menuSections = [
  {
    items: [
      { label: "Dashboard", path: "/dashboard", icon: "solar:home-smile-angle-outline" },
      { label: "Bookings", path: "/bookings", icon: "solar:calendar-outline" },
      { label: "Passengers", path: "/passengers", icon: "solar:users-group-rounded-outline" },
    ],
  },
  {
    title: "Services",
    items: serviceMenuItems,
  },
  {
    title: "Finance",
    items: [
      { label: "Payments", path: "/payment-proof", icon: "solar:paperclip-2-outline" },
      { label: "Outstanding", path: "/wallet-credit", icon: "solar:wallet-outline" },
    ],
  },
  {
    title: "Agency",
    items: [
      ...agencyMenuItems,
      { label: "Documents", path: "/documents", icon: "solar:document-text-outline" },
      { label: "Reports", path: "/reports", icon: "solar:chart-2-outline" },
      { label: "Support", path: "/support", icon: "solar:headphones-round-outline" },
    ],
  },
];

export const serviceRouteRoots = serviceMenuItems.map((item) => item.path);

export const searchablePages = menuSections.flatMap((section) => section.items || []);

export const htmlPageRouteMap = {
  "index.html": "/dashboard",
  "login.html": "/login",
  "register.html": "/register",
  "agency-detail.html": "/agency-detail",
  "packages.html": "/packages",
  "package-detail.html": "/packages/ramadan-premium-2026",
  "package-booking.html": "/packages/ramadan-premium-2026/book",
  "hotels.html": "/hotels",
  "hotel-detail.html": "/hotels/al-hidayah-tower",
  "hotel-booking.html": "/hotels/al-hidayah-tower/book",
  "transportation.html": "/transportation",
  "transportation-detail.html": "/transportation/jeddah-airport-to-makkah",
  "transportation-booking.html": "/transportation/jeddah-airport-to-makkah/book",
  "visas.html": "/visas",
  "visa-detail.html": "/visas/saudi-umrah-visa",
  "visa-booking.html": "/visas/saudi-umrah-visa/book",
  "flights.html": "/flights",
  "flight-detail.html": "/flights/mumbai-to-jeddah",
  "flight-booking.html": "/flights/mumbai-to-jeddah/book",
  "ziyarath-packages.html": "/ziyarat-packages",
  "ziyarath-package-detail.html": "/ziyarat-packages/makkah-holy-sites",
  "ziyarath-package-booking.html": "/ziyarat-packages/makkah-holy-sites/book",
  "bookings.html": "/bookings",
  "booking-detail.html": "/bookings/UMR-2408-001",
  "wallet-credit.html": "/wallet-credit",
  "documents.html": "/documents",
  "reports.html": "/reports",
  "support.html": "/support",
  "users.html": "/users",
  "settings.html": "/settings",
  "payment-proof.html": "/payment-proof",
  "passengers.html": "/passengers",
};

export const registrationSteps = [
  "Agency Details",
  "Business Setup",
  "Business & Tax",
  "KYC Documents",
];

export const registrationInitialValues = {
  agencyName: "",
  ownerName: "",
  email: "",
  mobile: "",
  city: "",
  state: "",
  address: "",
  businessType: "",
  website: "",
  yearsInBusiness: "",
  gst: "",
  pan: "",
  ownerIdProof: null,
  gstCertificate: null,
  panCard: null,
  tradeLicense: null,
  bankProof: null,
  travelCert: null,
  ownerProof: null,
  terms: false,
};
